class LoadParams {

    constructor() {

        this.loader = '.personalizator__product-loading';
        this.product = '.personalizator__product';
        this.loaderClass = 'personalizator__product--loading';
        this.svgs = '.personalizator__product-image-content svg';

        this.front = '.personalizator__front';

        this.getParams();

    }

    get selectedId() {
        if ($(`#variant_${$('.variant-sizes').val()}`).length) {
            return $(`#variant_${$('.variant-sizes').val()}`).data('id');
        }

        return null;
    }

    getParams() {
        $(document).ready(() => {
            if ($(this.product).length) {

                fetch(`/personalizacja/checkColor/${this.selectedId}`)
                    .then(response => response.json())
                    .then((response) => {
                        let color;

                        if (response.color) {
                            color = response.color;
                        } else {
                            color = '#FFFFFF';
                        }

                        this.pickColor(color);
                    });
            }
        });

    }

    pickColor(color) {

        $(this.svgs).each((index, element) => {
            $(element).find('.global').css('fill', color);
        });

        this.hideLoader();

    }

    hideLoader() {
        setTimeout(() => {
            $(this.loader).hide();
            $(this.product).removeClass(this.loaderClass);
            $(this.front).addClass('active');
        }, 3000);
    }

}

export const loadParams = new LoadParams();
